import { createElement } from 'react';
import Head from 'next/head';

var generateFontLinks = function generateFontLinks(fonts, loading) {
  if (!fonts || !fonts.length || !loading || loading === "none") {
    return null;
  }

  if (loading === "multiple") {
    return /*#__PURE__*/createElement(Fragment, null, fonts.map(function (font) {
      var name = font.name.split(" ").join("+");
      var style = font.styles.join(",");
      return /*#__PURE__*/createElement("link", {
        href: "//fonts.googleapis.com/css?family=" + name + ":" + style,
        rel: "stylesheet",
        type: "text/css"
      });
    }));
  }

  if (loading === "single") {
    var namesAndStyles = fonts.map(function (font) {
      var name = font.name.split(" ").join("+");
      var style = font.styles.join(",");
      return name + ":" + style;
    }).join("|");
    return /*#__PURE__*/createElement("link", {
      href: "//fonts.googleapis.com/css?family=" + namesAndStyles,
      rel: "stylesheet",
      type: "text/css"
    });
  }

  if (process.env.NODE_ENV === "development") {
    console.warn("Expected property `googleFontLoading` to be one of: \"single\", \"multiple\" or \"none\"");
  }

  return null;
};

var NextTypography = function NextTypography(_ref) {
  var typography = _ref.typography,
      googleFontLoading = _ref.googleFontLoading;
  var style = typography.createStyles();
  var fontLinks = generateFontLinks(typography.options.googleFonts, googleFontLoading);
  return /*#__PURE__*/createElement(Head, null, /*#__PURE__*/createElement("style", {
    id: "typography.js",
    dangerouslySetInnerHTML: {
      __html: style
    }
  }), fontLinks);
};

export default NextTypography;
